import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Switch as RouterSwitch, Route, Redirect, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import { withNamespaces } from 'react-i18next';
import NotificationSystem from 'rc-notification';
import { isEqual } from 'lodash';
import Tabs from 'components/Tabs';
import NavLinkWrapper from 'components/Tabs/NavLinkWrapper';
import { NOTIFICATION_NODE_STYLE } from 'constants/misc';
import BasicNotification from 'components/Notification';
import LaunchConfirmationModal from 'components/modals/LaunchConfirmationModal';
import WarningNotificationDialog from 'components/modals/WarningNotificationDialog';
import ConfirmationModal from 'components/modals/ConfirmationModal';
import ClickToEdit from 'components/forms/EditInline';
import {
  updateSequence,
  getSequence,
  destroySequence,
  duplicateSequence,
} from 'redux/actions/sequenceActions';
import {
  campaignDetailUrl,
  sequenceTab,
  sequenceStepsTab,
  sequenceCustomizePitchesTab,
  sequenceTabUrl,
  sequenceStepsTabUrl,
  sequenceCustomizePitchesTabUrl,
} from 'constants/routing';
import { getBadgeStatus } from 'constants/campaign';
import { Can, AbilityContext } from 'utils/permissions';
import { secondaryText } from 'themes/colors';
import { redirectApp } from 'utils/misc';
import { changeDocumentTitle } from 'utils/hooks';
import StatusBadge from 'containers/Campaigns/StatusBadge';
import classNames from 'classnames';
import StepsTab from './StepsTab';
import ContactsTab from './ContactsTab';
import SettingsModal from './SettingsModal';
import { LoadingTitle } from '../../../components/titles/PageTitle';
import CustomizePitchesTab from './CustomizePitchesTab';
import withGotoSettingsModal from './withGotoSettingsModal';


class SequenceDetail extends Component {
  static propTypes = {
    sequence: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      status: PropTypes.bool,
      launch_date_time_zone: PropTypes.string,
      campaign: PropTypes.number.isRequired,
      variable_error: PropTypes.bool,
    }).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    updateSequence: PropTypes.func.isRequired,
    getSequence: PropTypes.func.isRequired,
    destroySequence: PropTypes.func.isRequired,
    duplicateSequence: PropTypes.func.isRequired,
    sequenceContacts: PropTypes.shape({
      total_contacts: PropTypes.number,
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
      }),
      path: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired,
    toggleConfirmGoToSettingsModal: PropTypes.func,
  };

  static defaultProps = {
    toggleConfirmGoToSettingsModal: () => {},
  }

  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      status: props.sequence.status,
      isConfirmOffModalOpen: false,
      warningOpen: false,
    };
    this.handleEdit = this.handleEdit.bind(this);
  }

  componentDidMount() {
    this.props.getSequence(this.props.match.params.id);
    // eslint-disable-next-line no-return-assign
    NotificationSystem.newInstance({ style: { zIndex: '9999' } }, n => this.notification = n);
  }
  componentDidUpdate() {
    const { sequence } = this.props;
    changeDocumentTitle(sequence?.name);
  }
  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.sequence.status, this.props.sequence.status)) {
      this.setState({ status: nextProps.sequence.status });
    }
  }

  componentWillUnmount() {
    this.notification.destroy();
  }

  setSequenceToFalse = () => {
    this.props.updateSequence(this.props.match.params.id, { status: false }, true);
  }

  toggle = () => {
    this.setState({
      isModalOpen: !this.state.isModalOpen,
      status: this.state.isModalOpen ? false : this.state.status,
    });
  }

  toggleIsConfirmOffModalOpen = () => {
    this.setState({ isConfirmOffModalOpen: !this.state.isConfirmOffModalOpen });
  }

  closeWarning = () => {
    this.setState({ warningOpen: false });
  }

  handleEdit(sequenceName) {
    if (sequenceName) {
      this.props.updateSequence(this.props.match.params.id, { name: sequenceName }, true);
    }
  }

  deleteSequence = async () => {
    this.setState({
      isModalOpen: false,
    });
    await this.props.destroySequence(this.props.sequence.id);
    this.props.history.push(campaignDetailUrl(this.props.sequence.campaign));
  }

  showNotification = (message) => {
    this.notification.notice({
      content: <BasicNotification
        color="danger"
        message={message}
      />,
      duration: 2,
      closable: false,
      style: NOTIFICATION_NODE_STYLE,
      className: 'alert--colored right-up',
    });
  }

  saveSequence = async (launch) => {
    this.setState({
      isModalOpen: false,
      isConfirmOffModalOpen: false,
    });
    try {
      await this.props.updateSequence(this.props.match.params.id, { status: launch }, true);
    } catch (error) {
      this.setState({ status: false });
      this.showNotification(error.errors.status);
    }
    // if (launch && this.props.sequence.variable_error) {
    //   this.setState({ warningOpen: true });
    // }
  }

  openModal = () => {
    this.toggle();
    this.setState({ status: true });
  }

  handleDuplicateSequence = () => {
    this.props.duplicateSequence(this.props.sequence.id).then((res) => {
      if (res.value.status === 200 || res.value.status === 201) {
        redirectApp(sequenceTabUrl(res.value.data.id));
      } else {
        this.props.getSequence(this.props.match.params.id);
      }
    });
  }

  handleStatusChange = (value) => {
    const { sequence, toggleConfirmGoToSettingsModal } = this.props;
    if (value && sequence.launch_date) {
      this.openModal();
    } else if (value && !sequence.launch_date) {
      toggleConfirmGoToSettingsModal(sequence);
    } else {
      this.toggleIsConfirmOffModalOpen();
    }
  }

  render() {
    const {
      isModalOpen,
      status,
      isConfirmOffModalOpen,
      warningOpen,
    } = this.state;
    const { sequence, sequenceContacts } = this.props;
    const isSequenceLoaded = parseInt(this.props.match.params.id, 10) === sequence.id && sequence.loaded;
    return (
      <Container>
        <Row>
          {(isSequenceLoaded && sequenceContacts.loaded) &&
            <LaunchConfirmationModal
              isOpen={isModalOpen}
              toggle={this.toggle}
              launchDateTz={sequence.launch_date_time_zone}
              launchDate={sequence.launch_date}
              totalContacts={sequenceContacts.pending_contacts}
              onDelete={this.deleteSequence}
              onSave={this.saveSequence}
              onSaveLaunch={this.saveSequence}
            />
          }
          <WarningNotificationDialog
            errorMessage={
              <>
                Your Campaign has been Scheduled to Launch.
                <br /><br />
                However, note it will not send to some contacts due to missing variables.
                Filter contacts by 'Status-Delivery' is 'Variable Error' to review.
              </>
            }
            isOpen={warningOpen}
            toggle={this.closeWarning}
          />
          <ConfirmationModal
            open={isConfirmOffModalOpen}
            onBackdropClick={() => this.toggleIsConfirmOffModalOpen(false)}
            title="Warning"
            confirmLabel="Accept"
            confirmBtnColor="primaryCTA"
            onConfirmClick={() => this.saveSequence(false)}
            onCancelClick={() => this.toggleIsConfirmOffModalOpen(false)}
          >
            <span>Are you sure you want to turn off <strong>&#34;{this.props.sequence.name}&#34;</strong>?</span>
            <br />It will continue to poll responses but stop sending emails for this sequence.
          </ConfirmationModal>

          <Col md={12} className="mb-5 sequence-detail">
            <Row>
              <Col xs={12} sm={7} md={8} lg={9}>
                {!isSequenceLoaded ?
                  <React.Fragment>
                    <Link
                      className="font-weight-normal breadcrumb-volt loading-dots"
                      to="/404"
                    >
                      Loading /
                    </Link>
                    <LoadingTitle />
                  </React.Fragment> :
                  <React.Fragment>
                    <div>
                      <Link
                        className="d-inline-block font-weight-normal breadcrumb-volt"
                        to={campaignDetailUrl(this.props.sequence.campaign)}
                      >
                        <div className="flex">
                          <ArrowBackIcon /> <span>{sequence.campaign_name} /</span>
                        </div>
                      </Link>
                    </div>
                    <div className="account__name-container">
                      <ClickToEdit
                        wrapperClass="page-title"
                        textClass="account__name_custom"
                        value={this.props.sequence.name}
                        endEditing={this.handleEdit}
                        disabled={!this.context.can('edit', 'Sequence  label')}
                      />
                      <div
                        className={classNames('switch-inline', {
                          visible: isSequenceLoaded,
                          invisible: !isSequenceLoaded,
                        })}
                      >
                        <StatusBadge
                          className="mt-2"
                          status={getBadgeStatus({ status })}
                          handleStatusChange={
                            this.context.can('toggle', 'Sequence') ?
                              arg => this.handleStatusChange(arg) : null
                          }
                        />
                      </div>
                    </div>
                  </React.Fragment>
                }
              </Col>
              <Col xs={12} sm={5} md={4} lg={3}>
                <div className="settings-right">
                  <Can I="copy" a="Sequence">
                    <Tooltip title="Duplicate Sequence">
                      <IconButton onClick={this.handleDuplicateSequence}>
                        <FileCopyIcon style={{ color: secondaryText, opacity: 0.8 }} />
                      </IconButton>
                    </Tooltip>
                  </Can>
                  <Can I="see" a="Sequence Settings">
                    <div className="setting-icons">
                      <SettingsModal />
                    </div>
                  </Can>
                </div>
              </Col>
            </Row>
            <Card>
              <Tabs>
                <NavLinkWrapper
                  exact
                  to={sequenceTabUrl(this.props.match.params.id)}
                  className="nav-link"
                >
                  Contacts
                </NavLinkWrapper>
                <NavLinkWrapper
                  to={sequenceStepsTabUrl(this.props.match.params.id)}
                  className="nav-link"
                >
                  Steps
                </NavLinkWrapper>
                <NavLinkWrapper
                  to={sequenceCustomizePitchesTabUrl(this.props.match.params.id)}
                  className="nav-link"
                >
                  Customize by Contact
                </NavLinkWrapper>
              </Tabs>
              <CardBody>
                <RouterSwitch>
                  <Route path={sequenceTab} exact component={ContactsTab} />
                  <Route path={sequenceStepsTab} component={StepsTab} />
                  <Route path={sequenceCustomizePitchesTab} component={CustomizePitchesTab} />
                  <Redirect to="/404" />
                </RouterSwitch>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

SequenceDetail.contextType = AbilityContext;

export default compose(
  withNamespaces('common'),
  withGotoSettingsModal,
  connect(
    state => ({
      sequenceContacts: state.sequenceContacts,
      sequence: state.sequence,
    }),
    {
      updateSequence, getSequence, destroySequence, duplicateSequence,
    },
  ),
)(SequenceDetail);
